import Cookies from "js-cookie";

export const CLIENT_MEDIA_REFERENCE = "Client";
export const EMPLOYEE_MEDIA_REFERENCE = "Employee";

export const formatFieldName = (str) => {
  if (!str) return "";
  return str
    .replace(/([A-Z])/g, " $1")
    .replace(/^./, (char) => char.toUpperCase())
    .trim();
};

export const formatDate = (dateString) => {
  const date = dateString ? new Date(dateString) : new Date();
  const options = { weekday: "long", day: "numeric", month: "long" };
  return date.toLocaleDateString("en-US", options);
};

export const formatTime = (dateString) => {
  const date = new Date(dateString);
  return date.toLocaleTimeString("en-US", {
    hour: "2-digit",
    minute: "2-digit",
  });
};

export const getAddressFromCoords = async (latitude, longitude) => {
  try {
    const response = await fetch(
      `https://nominatim.openstreetmap.org/reverse?format=json&lat=${latitude}&lon=${longitude}`
    );
    const data = await response.json();
    return data.display_name || "";
  } catch (error) {
    console.error("Error getting address:", error);
    return "";
  }
};

// =============================
// Format date as YYYY-MM-DD
// =============================
export const formatDateOnly = (date) => {
  if (!date) return "";

  const d = new Date(date);
  if (isNaN(d)) return "";

  const year = d.getFullYear();
  const month = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");

  return `${year}-${month}-${day}`;
};

// =============================
// Format time as 12-hour (hh:mm AM/PM)
// =============================
export const formatTime12Hour = (date) => {
  if (!date) return "";

  const d = new Date(date);
  if (isNaN(d)) return "";

  let hours = d.getHours();
  let minutes = d.getMinutes();
  const ampm = hours >= 12 ? "PM" : "AM";

  hours = hours % 12 || 12; // Convert to 12-hour format
  minutes = String(minutes).padStart(2, "0");

  return `${hours}:${minutes} ${ampm}`;
};

export const getMediaBase64 = async (url) => {
  if (!url) return null;

  try {
    const token = Cookies.get("clientToken");
    const accountToken = Cookies.get("webapitoken");
    const response = await fetch(url, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
        webapitoken: accountToken,
      },
    });

    if (!response.ok) throw new Error("Failed to fetch media");

    const blob = await response.blob();

    return await new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result);
      reader.onerror = reject;
      reader.readAsDataURL(blob);
    });
  } catch (err) {
    return null;
  }
};

export const getDateMonthsAgo = (months) => {
  const date = new Date();
  date.setMonth(date.getMonth() - months);
  return date;
};

export const getProfilePicture = async (profileMedia) => {
  if (profileMedia && profileMedia.MediaUrl) {
    return await getMediaBase64(profileMedia.MediaUrl);
  } else {
    return "";
  }
};

export const computeDays = (start, end, option = "whole") => {
  if (!start || !end) return 0;

  const s = new Date(start);
  const e = new Date(end);

  let diff = (e - s) / (1000 * 60 * 60 * 24) + 1;

  if (option === "half") diff = 0.5;

  return diff;
};

export const combineDateWithTime = (dateString, timeString) => {
  const date = new Date(dateString);
  const [hours, minutes] = timeString.split(":");
  date.setHours(parseInt(hours), parseInt(minutes), 0, 0);
  return date;
};
